import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/app` is not a screen; the ledger is the home of this product. */
export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/ledger', replace: true });
  },
});
